import { FieldGroup } from "@repo/ui/ui/field";

import type { DatasourceForm } from "./datasource-new.types";

/** ClickHouse credential fields. */
export const ClickHouseFields = ({ form }: { form: DatasourceForm }) => (
  <FieldGroup>
    <form.AppField name="url">
      {(field) => (
        <field.TextField
          label="URL"
          placeholder="https://your-instance.clickhouse.cloud:8443"
        />
      )}
    </form.AppField>

    <div className="grid grid-cols-2 gap-4">
      <form.AppField name="username">
        {(field) => <field.TextField label="Username" placeholder="default" />}
      </form.AppField>

      <form.AppField name="password">
        {(field) => (
          <field.PasswordField label="Password" placeholder="••••••••" />
        )}
      </form.AppField>
    </div>

    <form.AppField name="chDatabase">
      {(field) => <field.TextField label="Database" placeholder="default" />}
    </form.AppField>
  </FieldGroup>
);
